import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Delete } from "@mui/icons-material";
import { layoutStyle } from "../pages/layout-ui/style";
import { useNavigate } from "react-router-dom";
import { useMovableColumn, useUser } from "../common/hooks";
import { localStorageItemNames } from "../common/constants";
import { PageNameConstant } from "../common/constants/PageNameConstant";

export const PopupBlock = ({
  open,
  close,
  deleteApi,
  setOpen,
  navigationRouteNext,
  navigationRoutePrev,
  selectedNavStyle,
  columnChangeData,
  pageName,
}) => {
  const classes = layoutStyle();
  const navigation = useNavigate();
  const {
    setSelectedNav,
    sidebarColumnPopup,
    selectedNav,
    setPopupBlock,
    setColumnChange,
    selectedSaveNav,
  } = useUser();
  const {
    movableColumn,
    getMovableColumnApi,
    createMovableColumn,
    updateViewMovableColumn,
    setMovableColumn,
  } = useMovableColumn();

  const handleClick = async () => {
    if (movableColumn?.length > 0) {
      await updateViewMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: pageName,
        ColumnName: JSON.stringify(columnChangeData),
        id: movableColumn[0]?.id,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      });
    } else {
      await createMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: pageName,
        ColumnName: JSON.stringify(columnChangeData),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      });
    }
    if (sidebarColumnPopup) {
      // setSelectedNav(selectedNav);
      navigation(`/${sidebarColumnPopup}`);
    } else {
      if (navigationRouteNext) {
        navigation(navigationRouteNext);
        setSelectedNav(selectedSaveNav);
      } else if (navigationRoutePrev) {
        navigation(navigationRoutePrev);
        setSelectedNav(selectedNavStyle);
      }
    }
    setOpen(false);
    setPopupBlock(false);
    setMovableColumn([]);
  };

  const handleClose = () => {
    console.log("sidebarColumnPopup", sidebarColumnPopup);
    if (sidebarColumnPopup) {
      setSelectedNav(selectedNav);
      navigation(`/${sidebarColumnPopup}`);
    } else {
      if (navigationRouteNext) {
        setSelectedNav(selectedNavStyle);
        navigation(navigationRouteNext);
      } else if (navigationRoutePrev) {
        setSelectedNav(selectedNavStyle);
        navigation(navigationRoutePrev);
      }
    }
    setMovableColumn([]);
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure you want to move without saving columns?"}
        </DialogTitle>
        <DialogActions>
          <Button
            variant="outlined"
            type="submit"
            className={classes.deleteCancelButton}
            autoFocus
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            type="submit"
            className={classes.deleteOkButton}
            onClick={handleClick}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
